import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { TrayStateModule } from "@hermes/states/tray";

import { LoadingScreenComponent } from "../loading-screen/loading-screen.component";

import { DrupalTraySrcPipe } from "./pipes/drupal-tray-src.pipe";

@NgModule({
    declarations: [DrupalTraySrcPipe, LoadingScreenComponent],
    exports: [DrupalTraySrcPipe, LoadingScreenComponent],
    imports: [CommonModule, TrayStateModule],
})
export class DrupalTrayStateModule {}
